<template>
  <form method="POST">
    <section class="paper-upload-wrapper">
      <div class="upload-header">
        <h2 class="title">Add Papers</h2>
      </div>

      <div class="notification-wrapper">
        <div v-if="!isHidden" class='notification is-danger'>
          {{ errorMessage }}
        </div>
      </div>

      <div class="card paper-card">
        <b-field label="Author" message="Please enter an author">
          <b-input name="author" v-model="authorName" expanded></b-input>
        </b-field>
        <b-field label="Title" message="Please enter a title">
          <b-input name="title" v-model="title" expanded></b-input>
        </b-field>
        <div class="columns">
          <b-field
            label="Year"
            class="column is-half"
            message="Please enter the year of document"
          >
            <b-input name="year" v-model="year"></b-input>
          </b-field>
          <b-field class="column is-half" label="Topic">
            <multiselect
              v-model="topics"
              :options="getOptions(topicOptions)"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Click to select"
              label="name"
              track-by="value"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
          </b-field>
        </div>
        <div class="columns">
          <b-field class="column is-half" label="Language">
            <multiselect
              v-model="language"
              :options="getOptions(languageOptions)"
              :multiple="false"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Click to select"
              label="name"
              track-by="value"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
          </b-field>
          <b-field class="column is-half" label="Region">
            <multiselect
              v-model="region"
              :options="getOptions(regionOptions)"
              :multiple="false"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Click to select"
              label="name"
              track-by="value"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
          </b-field>
        </div>
        <div class="columns">
          <b-field class="column is-half" label="Category">
            <multiselect
              v-model="category"
              :options="getOptions(categoryOptions)"
              :multiple="false"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Click to select"
              label="name"
              track-by="value"
              :preselect-first="false"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} options selected</span
                ></template
              >
            </multiselect>
          </b-field>
          <b-field
            label="Tags"
            class="column is-half"
            message="Please enter the tags for document (Separated by Comma(,))"
          >
            <b-input name="Tags" v-model="tags"></b-input>
          </b-field>
        </div>
        <div class="columns">
          <b-field class="column is-half" label="SDGs">
            <multiselect
            v-model="sdgs"
            :options="sdgOptions"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Click to select"
            label="name"
            track-by="value"
            :preselect-first="false">
              <template slot="selection"
              slot-scope="{ values, isOpen }">
              <span class="multiselect__single"
               v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
               options selected</span>
               </template>
          </multiselect>
          </b-field>
          <b-field v-if="available" class="column is-half"
            label="URL"
            message="Please enter the url for document"
          >
            <b-input name="URL" v-model="url"></b-input>
          </b-field>
        </div>
        <b-field>
          <b-switch
            type="is-success"
            v-model="available"
            v-on:click="available = !available"
            >
            Available online
          </b-switch>
        </b-field>
        <section class="drop-files">
          <b-field>
            <b-upload v-model="dropFiles" multiple drag-drop>
              <section class="section">
                <div class="content has-text-centered is-dark">
                  <p>
                    <b-icon icon="upload" size="is-large"> </b-icon>
                  </p>
                  <p>Drop your files here or click to upload</p>
                </div>
              </section>
            </b-upload>
          </b-field>

          <div class="tags">
            <span
              v-for="(file, index) in dropFiles"
              :key="index"
              class="tag is-primary"
            >
              {{ file.name }}
              <button
                class="delete is-small"
                type="button"
                @click="deleteDropFile(index)"
              ></button>
            </span>
          </div>
        </section>
      </div>
      <!-- TODO API CALL -->
      <b-field grouped position="is-centered">
        <b-button
          size="is-medium"
          label="Submit"
          type="is-info"
          position="is-centered"
          @click="createPaper"
        />
      </b-field>
    </section>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {
  topicOptions,
  categoryOptions,
  languageOptions,
  regionOptions,
  sdgOptions
} from '@/options'
import { PAPER_MUTATION } from '@/graphql'

export default {
  name: 'Papers',
  components: {
    Multiselect
  },
  data () {
    return {
      authorName: '',
      title: '',
      year: '',
      topics: '',
      language: '',
      category: '',
      available: false,
      tags: '',
      sdgs: [],
      url: '',
      region: '',
      // Drop down options
      categoryOptions: categoryOptions,
      languageOptions: languageOptions,
      regionOptions: regionOptions,
      topicOptions: topicOptions,
      dropFiles: [],
      sdgOptions: sdgOptions,
      file: {},
      isHidden: true,
      errorMessage: ''
    }
  },
  methods: {
    getOptions: function (optionsDict) {
      return Object.keys(optionsDict).map((key, idx) => {
        return { name: optionsDict[key], value: key }
      })
    },
    deleteDropFile: function (index) {
      this.dropFiles.splice(index, 1)
    },
    graphQLErrorMessages: function (errorsFromCatch) {
      const errorMsg = errorsFromCatch.networkError.result.errors[0].message
      return errorMsg
    },
    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    async createPaper () {
      let documentPayload = {}
      const uploadPaper = () => {
        this.isHidden = true
        this.$apollo
          .mutate({
            mutation: PAPER_MUTATION,
            variables: {
              authors: this.authorName,
              topics: this.topics && this.topics.map(topic => topic.value),
              title: this.title,
              category: this.category && this.category.value,
              year: this.year && parseInt(this.year),
              tags: this.tags.split(','),
              sgds: this.sdgs && this.sdgs.map(e => e.value),
              region: this.region && this.region.value,
              language: this.language && this.language.value,
              availeble: this.available,
              url: this.url,
              document: [documentPayload]
            }
          })
          .then((response) => {
            this.isHidden = true
            console.log('response', response)
            // redirect to the details page
            this.$router.replace(`/papers/details/${response.data.createPaper.paper.id}`)
          }).catch(error => {
            this.isHidden = false
            this.errorMessage = this.graphQLErrorMessages(error)
            console.log(this.graphQLErrorMessages(error))
            this.scrollToTop()
          })
      }
      if (this.dropFiles.length > 0) {
        const file = this.dropFiles[0]
        const reader = new FileReader()
        reader.onload = (e) => {
          const base64String = reader.result
          documentPayload = {
            filename: file.name,
            contentType: file.type,
            data: base64String // Send Base64 data
          }
          uploadPaper()
        }
        await reader.readAsDataURL(file)
      } else {
        uploadPaper()
      }
    }

    /* authors = graphene.List(graphene.String)
        topics = graphene.List(graphene.String)
        title = graphene.String(required=True)
        category = graphene.String(required=True)
        year = graphene.Int(required=False)
        tags = graphene.List(graphene.String)
        sgds = graphene.List(graphene.String)
        region = graphene.String(required=True)
        language = graphene.String(required=True)
        availeble = graphene.Boolean(required=False)
        url = graphene.String(required=False)
        available = graphene.Boolean(required=False) */

  }
}
</script>
<style>
.paper-upload-wrapper {
  max-width: 980px;
  margin: 0 auto;
  padding: 2rem 1rem 3rem;
}
.upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}
.upload-header .title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1b3d2f;
}
.drop-files {
  border: 2px dashed #c8dbd3;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #fbfdfb;
}
.drop-files .section {
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paper-card {
  border-radius: 1rem;
  margin-bottom: 2rem;
  padding: 2.5rem;
}
.notification-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}
.notification {
  animation-name: fadein;
  animation-duration: 2s;
}
.tags {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/AddPaper.vue